<template>
  <div class="diseaseCode">
    <div class="warpper">
      <div class="top">
        <div class="keyword">
          <el-input
            v-model="keyword"
            placeholder="请输入关键字搜索医院"
            @keyup.enter.native="search()"
          ></el-input>
        </div>
        <div class="btn">
          <el-button type="primary" @click="search()">搜索</el-button>
        </div>
      </div>
      <div class="content" v-if="doctorList.length > 0">
        <div class="left">
          <div class="drug-item" v-for="(item, index) in doctorList" :key="index">
            <div class="_item-title">
              <el-radio
                v-model="doctorItem"
                :label="index"
                @change="durgChange"
                >{{item.name}}</el-radio>
              <!-- <span class="code-type">{{item.name}}</span> -->
            </div>
          </div>
          <div class="left_foo">
            <el-pagination
              small
              @current-change="currentPageChange"
              :page-size="page.pageSize"
              :current-page="page.pageNo"
              :total="page.total"
              layout="total, prev, pager, next"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
/**
 * @name 科室列表弹窗
 * @desc 数据列表
 */
import util from "@/utils";
import { getHospital  } from "@/api";
export default {
  props: {
    drugs: Array,
  },
  data() {
    return {
      keyword: "",
      doctorList:[],
      doctorItem:'',
      type: "",
      page: {
        pageNo: 1,
        pageSize: 10,
        total: "",
      },
      // durgList: [],
      // caseForm: {
      //   drugs_id: "",
      //   quantity: "",
      //   dosage: "",
      //   unit: "",
      //   frequency: "",
      //   from: "",
      //   time: "",
      //   remark: "",
      // },
      // durgItem: "",
      curCase: "",
      edit: false,
      rightShow: false,
    };
  },
  mounted() {
    this.readyDoctor()
  },
  methods: {
    /**
     * 全部
     */
    search() {
      this.page.pageNo = 1;
      this.rightShow = false;
      this.readyDoctor();
    },
    //初始化数据项
    // async init() {
    //   try {
    //     let params = {
    //       type: this.type,
    //       title: this.keyword,
    //       pageNo: this.page.pageNo,
    //       pageSize: this.page.pageSize,
    //     };
    //     let res = await disease_code(params);
    //     if (res.success) {
    //       this.durgList = res.result.records;
    //       this.durgItem = "";
    //       this.page.pageNo = res.result.current;
    //       this.page.total = res.result.total;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    //分页
    currentPageChange(e) {
      this.page.pageNo = e;
      this.rest();
      this.readyDoctor();
    },
    //选择事件
    durgChange(e) {
      console.log(e);
      this.rightShow = true;
      this.curCase = this.doctorList[e];
      console.log("this.curCase", this.curCase);
      this.$emit("on_hosiptal_code", this.curCase, false);
    },
    rest() {
      this.edit = false;
      this.rightShow = false;
      this.curCase = "";
      this.doctorItem = "";
    },
     //获取科室
    async readyDoctor() {  
      try {
        const params = {
          hospitalId: '',
          name: this.keyword,
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        };
        let res = await getHospital(params);
        if (res.success) {
          const {records ,total,current} = res.result;
          this.doctorList = records;
          this.page.pageNo = current;
          this.page.total = total;          
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

  },
};
</script>

<style lang="scss" type="text/css">
.diseaseCode {
  padding: 5%;
  .warpper { 
    .top {
      display: flex;
      color: #999999;
      ._op {
        flex: 0 0 20%;
        display: flex;
        align-items: center;
      }
      .keyword {
        flex: 1;
        display: flex;
        margin-right: 10%;
        align-items: center;
      }
    }

    .content {
      display: flex;
      margin: 20px 0 0 0;
      .left {
        flex: 1;
        border: none;
        margin-right: 5px;
        .drug-item {
          background: #fafafa;
          margin: 10px 0 0 0;
          padding-right: 20px;
          ._item-title {
            display: flex;
            align-items: center;
            padding: 10px 20px;
          }
        }
        .left_foo {
          margin-top: 15px;
          text-align: center;
          font-size: 22px;
          // i:nth-child(1) {
          //   margin-right: 20px;
          // }
        }
      }
      .right {
        flex: 0 0 50%;
        .foo {
          display: flex;
        }
      }
    }
    .emptyDataCenter {
      // min-height: 500px;
      margin: 0 auto;
      align-items: center;
    }
  }
    .code-type{
    position: absolute;
    right: 90px;
  }
}
</style>
